import React, { useContext } from 'react';
import Icon from '../icon';
import { PhoneLink } from '../link';
import context from '../../context/product/context';
import { EventAction } from '../../../../services/ga';

const PhoneIcon: React.FC<{ phoneNumber: string, action: EventAction, className?: string }> = ({phoneNumber, action, className}) => {
    const ctxt = useContext(context);
    return (
        <PhoneLink phoneNumber={phoneNumber} action={action}>
            <div>
                <span className="sr-only">{ctxt.json.pages.icons.phone}</span>
                <Icon className={className || "h-6 w-6 text-brand"} type="phone" />
            </div>
        </PhoneLink>
    );
}

export default PhoneIcon;